/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum activeIncludeEnum {
    ALL = 'all',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}